import { render, staticRenderFns } from "./LimitedQuantitySpecification.vue?vue&type=template&id=fca67f2a&"
import script from "./LimitedQuantitySpecification.vue?vue&type=script&lang=ts&"
export * from "./LimitedQuantitySpecification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports